// extracted by mini-css-extract-plugin
export var cardPadding = "_4k-4";
export var collapseIcon = "_4k-1";
export var collapsed = "_4k-2";
export var leftRightShippingChevron = "_4k-3";
export var subtotalCollapseSection = "_4k-0";